import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api/axios";
import Table from "../../components/Table";
import ActionButtons from "../../components/ActionButtons";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import SearchBar from "../../components/SearchBar";
import LoadingOverlay from "../../components/LoadingOverlay";

function Clients() {
  const [clients, setClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchClients();
  }, []);

 const fetchClients = async () => {
  try {
    setLoading(true);
    const res = await api.get("/clients");
    setClients(res.data || []);
  } catch (error) {
    toast.error("Error al cargar clientes", "error");
  } finally {
    setLoading(false);
  }
};

  // Filtrar por nombre o descripción
  const filteredClients = clients.filter((client) =>
    `${client.name} ${client.description}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="bg-white p-6 rounded-xl shadow-md relative">
      <LoadingOverlay loading={loading} />
      <div className="flex flex-wrap items-center justify-between mb-6 gap-4">
        <h2 className="text-3xl font-semibold text-gray-800">Clientes</h2>
        <div className="flex gap-3 items-center">
          <SearchBar
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Link
            to="/clients/create"
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow flex items-center gap-2 transition duration-300 whitespace-nowrap"
          >
            <Plus size={18} />
            <span>Nuevo Cliente</span>
          </Link>
        </div>
      </div>

      <Table
        columns={[
          { label: "Nombre", key: "name", width: "w-1/2" },
          { label: "Descripción", key: "description", width: "w-1/2" },
        ]}
        data={filteredClients}
        renderActions={(client) => (
          <ActionButtons
            editUrl={`/clients/edit/${client.id}`}
            onDelete={() => client.id}
          />
        )}
      />
    </div>
  );
}

export default Clients;